<section class="smooth-scroll-anchor-shared" [ngClass]="styleClass" *ngIf="(serviceList$ | async)?.length">
  <div
    class="box"
    [ngClass]="{
      'below-four-items': (serviceList$ | async)?.length < 4
    }"
  >
    <div class="box-wrapper">
      <ng-container *ngFor="let item of serviceList$ | async">
        <ng-container *ngIf="translate.currentLang === 'th' ? item.data.link?.th : item.data.link?.en; else scrollBtn">
          <a
            class="box-wrapper__navigation"
            [href]="translate.currentLang === 'th' ? item.data.link.th : item.data.link.en"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div class="box-wrapper__navigation--icon">
              <img [src]="item.data.icon.iv" alt="icon-nav" />
            </div>
            <div class="box-wrapper__navigation--text">
              <span>{{ translate.currentLang === 'th' ? item.data.label.th : item.data.label.en }}</span>
            </div>
          </a>
        </ng-container>

        <ng-template #scrollBtn>
          <button class="box-wrapper__navigation" (click)="scrollToTarget(item.data.targetId?.iv)">
            <div class="box-wrapper__navigation--icon">
              <img [src]="item.data.icon.iv" alt="icon-nav" />
            </div>
            <div class="box-wrapper__navigation--text">
              <span>{{ translate.currentLang === 'th' ? item.data.label.th : item.data.label.en }}</span>
            </div>
          </button>
        </ng-template>
      </ng-container>
    </div>
  </div>
</section>
